import { Container, Link, Text } from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";
import type { QuoteHeadlineWithEditlinkProps } from "./types";

export const QuoteHeadlineWithEditlink = ({
  quoteCount,
  product,
  backLinkUrl,
  journeyId,
  vertical,
}: QuoteHeadlineWithEditlinkProps) => {
  const { snowplow } = useSnowplowContext();

  if (quoteCount === 0) {
    return null;
  }

  const handleBackLinkClick = () => {
    if (journeyId && vertical) {
      snowplow?.trigger("backToApplication", { journeyId, vertical });
    }
  };

  return (
    <Container size="sm">
      {backLinkUrl && (
        <Link
          href={backLinkUrl}
          className="mobius-quote-headline__link"
          onClick={handleBackLinkClick}
        >
          <span>Edit application</span>
        </Link>
      )}
      <Text className="mobius-quote-headline__title">
        Your <strong>{product}</strong> quotes
      </Text>
      <Text className="mobius-quote-headline__description">
        We searched through multiple carriers and found{" "}
        <strong>
          {quoteCount} quote{quoteCount > 1 ? "s" : ""}{" "}
        </strong>
        for your business
      </Text>
    </Container>
  );
};
